export default "__VITE_ASSET__CWp_0HXy__"